import React from "react";

import * as UI from "./ui";

const Contact = ({ donor }) => (
  <UI.Contact>
    <p>{donor.email}</p>
    <p>{donor.phoneNumber}</p>
  </UI.Contact>
);

const donorZipCode = donor => {
  if (donor.zipCode) {
    return donor.zipCode;
  }
  if (donor.zip) {
    return donor.zip;
  }
  return "";
}
const Address = ({ donor }) => (
  <UI.Address>
    <p>{donor.addressLine1} {donor.addressLine2}</p>
    <p>{donor.city}, {donor.state}, {donorZipCode(donor)} {donor.country}</p>
  </UI.Address>
);

const DonorCard = ({ donor, bordered = true, padded = true, flipped = false }) => (
  <UI.Layout $bordered={bordered} $padded={padded}>
    <UI.Name>{donor.firstName} {donor.lastName}</UI.Name>
    {flipped ? (
      <React.Fragment>
        <Contact donor={donor} />
        <Address donor={donor} />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Address donor={donor} />
        <Contact donor={donor} />
      </React.Fragment>
    )}
  </UI.Layout>
);

export default DonorCard;
